import { Navigate } from "react-router-dom";

/** @deprecated Use Manufacturing management → Settings. */
export function PreEncapsulationSettingsPage() {
  return <Navigate to="/manufacturing-management/settings#pre-encapsulation" replace />;
}
